module.exports = __webpack_public_path__ + "img/onexus-white.83367b51.png";